// noinspection NonAsciiCharacters

import { Food } from '../type';
import preval from 'preval.macro';
import { categories } from './category';

type InternalFood = {
  name: string;
  category: string;
};

export const internalFoods: Record<string, InternalFood> = preval`
  const fs = require('fs');
  const json = fs.readFileSync(__dirname + '/../../data/food.json', 'utf8');
  const object = JSON.parse(json);
  const convertInternal = (rawFoods) => {
    return Object.fromEntries(rawFoods['음식'].map((v) => ([v['음식명'], {
      name: v['음식명'],
      category: v['분류명'],
    }])));
  };
  module.exports = convertInternal(object);
`;

export const foods: Record<string, Food> = Object.fromEntries(
  Object.entries(internalFoods).map((foodEntry) => {
    const food_categories = foodEntry[1].category
      .split(',')
      .map((v) => {
        const res = categories[v.trim()];
        if (!res) console.warn(`Cannot find category ${v.trim()} of ${foodEntry[0]}`);
        return res;
      })
      .filter((v) => v);
    if (food_categories.length < 1) console.warn(`[WARN] Food ${foodEntry[0]}'s category is not exist.`);
    return [
      foodEntry[0],
      {
        name: foodEntry[1].name,
        category: food_categories,
      },
    ];
  }),
);
